/** Session-only record of the last rule merge per section, so a merge can be undone. */
import type { StateCreator } from 'zustand'
import type {
  RulesMergeHistoryState,
  RulesMergeRecord,
  RuleType,
} from './types'

export interface RulesMergeHistorySlice {
  rulesMergeHistory: RulesMergeHistoryState
  setRulesMergeRecord: (
    configId: string,
    section: RuleType,
    record: RulesMergeRecord | null
  ) => void
  clearRulesMergeHistory: (configId?: string) => void
}

export const EMPTY_RULES_MERGE_HISTORY: RulesMergeHistoryState = {
  configId: null,
  records: {},
}

export const createRulesMergeHistorySlice: StateCreator<
  RulesMergeHistorySlice,
  [],
  [],
  RulesMergeHistorySlice
> = (set) => ({
  rulesMergeHistory: EMPTY_RULES_MERGE_HISTORY,

  setRulesMergeRecord: (configId, section, record) =>
    set(({ rulesMergeHistory }) => {
      const { [section]: _replaced, ...others } =
        rulesMergeHistory.configId === configId ? rulesMergeHistory.records : {}

      return {
        rulesMergeHistory: {
          configId,
          records: record ? { ...others, [section]: record } : others,
        },
      }
    }),

  clearRulesMergeHistory: (configId) =>
    set(({ rulesMergeHistory }) =>
      configId !== undefined && rulesMergeHistory.configId !== configId
        ? {}
        : { rulesMergeHistory: EMPTY_RULES_MERGE_HISTORY }
    ),
})
